import { DropdownOptionModel } from '../models/dropdown-option.model';

export const promptLanguageOptions: DropdownOptionModel<string>[] = [
    new DropdownOptionModel('en-US.da', 'da'), // Danish
    new DropdownOptionModel('en-US.nl', 'nl'), // Dutch
    new DropdownOptionModel('en-US.en-US', 'en-US'), // English (US)
    new DropdownOptionModel('en-US.en-GB', 'en-GB'), // English (UK)
    new DropdownOptionModel('en-US.fi', 'fi'), // Finnish
    new DropdownOptionModel('en-US.fr', 'fr'), // French
    new DropdownOptionModel('en-US.fr-CA', 'fr-CA'), // French (Canadian)
    new DropdownOptionModel('en-US.de', 'de'), // German
    new DropdownOptionModel('en-US.it', 'it'), // Italian
    new DropdownOptionModel('en-US.no', 'nb'), // Norwegian
    new DropdownOptionModel('en-US.pt', 'pt'), // Portuguese
    new DropdownOptionModel('en-US.es', 'es'), // Spanish
    new DropdownOptionModel('en-US.sv', 'sv'), // Swedish
];

